<template>

  <b-modal id="FormsConfigurationUpdate" size="lg" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title">Editar Campo</h5>
      <button type="button" aria-label="Close" class="close" @click="close()">×</button>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form @submit.stop.prevent="editar" ref="form">

        <div class="form-row form-scroll modal_form">

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Nro de Orden *</label>
              <b-form-input class="module_dynamic_form_input" autofocus="autofocus" v-model="entidad.cs_order" type="number"  
                min="-100" max="100" required :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Tipo de campo *</label>
              <treeselect class="module_dynamic_form_combo" v-model="entidad.cs_component" :clearable="false" :disable-branch-nodes="true" placeholder="" :disabled="loading" required 
              :options="cs_component_options" :auto-load-root-options="false" :cache-options="false" :open-on-focus="true"/>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_component == 'input'">
              <label class="form_label_bold" for="browser_first_name">Tipo de contenido *</label>
              <treeselect class="module_dynamic_form_combo" v-model="entidad.cs_type" :clearable="false" :disable-branch-nodes="true" placeholder="" :disabled="loading" required 
              :options="cs_type_options" :auto-load-root-options="false" :cache-options="false" :open-on-focus="true"/>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_component == 'input'">
              <label class="form_label_bold" for="browser_first_name">Texto de fondo</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_placeholder" type="text"  
                :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_component == 'select'">
              <label class="form_label_bold" for="browser_first_name">Items (separados por |) *</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_items" type="text"  
                required :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_type == 'number'">
              <label class="form_label_bold" for="browser_first_name">Formato Decimal (Enteros: 0, Decimales: 0.1, 0.01, 0.001 ..) *</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_step" type="number"  
                required min="0" max="10" :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_type == 'number'">
              <label class="form_label_bold" for="browser_first_name">Valor mínimo</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_min" type="number"  
                :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_type == 'number'">
              <label class="form_label_bold" for="browser_first_name">Valor máximo</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_max" type="number"  
                :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_type == 'email'">
              <label class="form_label_bold" for="browser_first_name">Varios emails</label>
              <b-form-checkbox v-model="entidad.cs_multiple" :disabled="loading" 
              switch size="md"></b-form-checkbox>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_type == 'password'">
              <label class="form_label_bold" for="browser_first_name">Largo máximo</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_maxlength" type="number"  
                :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_type == 'tel'">
              <label class="form_label_bold" for="browser_first_name">Pattern (ejemplo: '[0-9]{3}-[0-9]{2}-[0-9]{3}')</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_pattern" type="text"  
                :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Nombre del campo *</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_model" type="text"  
                min="0" max="50" required :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Etiqueta del campo *</label>
              <b-form-input class="module_dynamic_form_input" v-model="entidad.cs_label" type="text"  
                min="0" max="50" required :disabled="loading"></b-form-input>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Visible en la Creación</label>
              <b-form-checkbox v-model="entidad.cs_visible_on_create" :disabled="loading" 
              switch size="md"></b-form-checkbox>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Visible en la Actualización</label>
              <b-form-checkbox v-model="entidad.cs_visible_on_update" :disabled="loading" 
              switch size="md"></b-form-checkbox>
          </div>

          <div class="col-lg-6 mb-3">
              <label class="form_label_bold" for="browser_first_name">Visible en la Atención</label>
              <b-form-checkbox v-model="entidad.cs_visible_on_attention" :disabled="loading" 
              switch size="md"></b-form-checkbox>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_visible_on_create">
              <label class="form_label_bold" for="browser_first_name">Requerido en la Creación</label>
              <b-form-checkbox v-model="entidad.cs_required_on_create" :disabled="loading" 
              switch size="md"></b-form-checkbox>
          </div>  

          <div class="col-lg-6 mb-3" v-if="entidad.cs_visible_on_update">
              <label class="form_label_bold" for="browser_first_name">Requerido en la Actualización</label>
              <b-form-checkbox v-model="entidad.cs_required_on_update" :disabled="loading" 
              switch size="md"></b-form-checkbox>
          </div>

          <div class="col-lg-6 mb-3" v-if="entidad.cs_visible_on_attention">
              <label class="form_label_bold" for="browser_first_name">Requerido en la Atención</label>
              <b-form-checkbox v-model="entidad.cs_required_on_attention" :disabled="loading" 
              switch size="md"></b-form-checkbox>
          </div>

        </div>

        <div class="modal-footer" style="padding: 1rem 0rem 0rem 0rem;">
          <button type="button" @click="hide()" class="btn btn-secondary" :disabled="loading">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>
      
    </template>
  </b-modal>

</template>

<script>

import moment from 'moment'
import Treeselect from '../utils/vue-treeselect/src/components/Treeselect'
import {es} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Treeselect,
    Datepicker
  },
  data () {
    return {
      loading: false,
      cs_component_options: [
        { id: 'input', label: 'Cuadro de Texto' },
        { id: 'select', label: 'Lista desplegable' },
        { id: 'checkbox', label: 'Checkbox' }
      ],
      cs_type_options: [
        { id: 'text', label: 'Texto' },
        { id: 'url', label: 'Url' },
        { id: 'email', label: 'Email' },
        { id: 'password', label: 'Contraseña' },
        { id: 'tel', label: 'Teléfono' },
        { id: 'datetime-local', label: 'Fecha y hora' },
        { id: 'date', label: 'Fecha' },
        { id: 'time', label: 'Hora' },
        { id: 'number', label: 'Número' }
      ],
      entidad: {},
      empresas: [],
      format: "dd/MM/yyyy",
      es: es
    }
  },
  methods: {
    setId (id) {
       try {
        if (!localStorage.signedIn) {
          this.$router.push('/')
        } else {
          this.entidad.id = id;

          this.getCasoAtributosForUpdate(localStorage.empresa_id,this.entidad.id)
            .then(data => {
              this.entidad = data.entidad
            })
        } 
      } catch (error) {
        this.showError(error)
      }
      
    },
    cs (str){
      return str.trim().replace(/'/g, ' ').replace(/"/g, " ").replace(/\t/g, ' ')
    },
    editar () {
      try {

        this.$http.secured.patch(`/desk/client/v1/v2_empresas/${localStorage.empresa_id}/v2_caso_atributos/${this.entidad.id}`, { v2_caso_atributo: this.entidad })
          .then(response => {            
            this.showOK("Se actualizó el campo correctamente!")
            this.$emit('closeModal')
            this.$refs.modal.hide()
          })
          .catch(error => {
            this.showError(error)
          })  
      } catch (error) {
        this.showError(error)
      }
    }
  }
}
</script>
